import React from 'react'

export const Kuznia = (): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="269.528"
    height="47.25"
    viewBox="0 0 269.528 47.25"
  >
    <g
      id="Group_417"
      data-name="Group 417"
      transform="translate(370.174 0.698)"
    >
      <path
        id="Path_872"
        data-name="Path 872"
        d="M-368.312,15.963l-1.621,1.33V28.56l1.621,1.33"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <rect
        id="Rectangle_1547"
        data-name="Rectangle 1547"
        width="18.874"
        height="46.77"
        rx="3.214"
        transform="translate(-368.312 -0.458)"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_873"
        data-name="Path 873"
        d="M-349.438,29.932l27.355-1.5h57.932a3.138,3.138,0,0,0,3.139-3.138V20.6a3.139,3.139,0,0,0-3.139-3.139h-57.932l-27.355-1.5"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_874"
        data-name="Path 874"
        d="M-136.726,16.38a3.844,3.844,0,0,0-2.042-1.7,19.007,19.007,0,0,0-4.6-1.226,121.422,121.422,0,0,0-14.3-.618l-27.563.291-67.973.291a1.873,1.873,0,0,1-1.124-1.683,1.848,1.848,0,0,1,1.081-1.7l61.362-.415,10.352-.208,10.31-.374,10.31-.541,10.268-.665a43.751,43.751,0,0,1,13.47,1.621l1.538.458,1.58.374,1.58.249a11.186,11.186,0,0,1,1.764.433"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_875"
        data-name="Path 875"
        d="M-125,15.32a7.083,7.083,0,0,0,1.969,2.487,16.731,16.731,0,0,0,10.62,5.324A13.411,13.411,0,0,0-102.5,20.16a1.257,1.257,0,0,1,1.418.614,1.31,1.31,0,0,1-.223,1.566,14.259,14.259,0,0,1-5.573,3.1,23.571,23.571,0,0,1-10.067.115,25.341,25.341,0,0,1-6.907-2.657l-2.461-1.737a4.548,4.548,0,0,0-3.091-.532c-.135.01-.291,0-.425.007"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_876"
        data-name="Path 876"
        d="M-135.885,23.26l-2.494,1.122-2.536,1-2.578.79-2.661.665-2.7.457L-159.083,28.5-169.31,29.87l-10.227,1.538-10.185,1.663L-250.128,43.88a1.811,1.811,0,0,1-1.368-1.442,1.771,1.771,0,0,1,.786-1.8l66.891-12.181,27.147-4.739,4.7-.915,4.615-1.081,4.614-1.247a19.093,19.093,0,0,0,4.33-2,3.883,3.883,0,0,0,1.8-2.442,7.47,7.47,0,0,1,6.306-5.115A4.491,4.491,0,0,0-127.4,9.79l2.146-2.114a25.555,25.555,0,0,1,6.326-3.907,23.58,23.58,0,0,1,9.921-1.732,14.162,14.162,0,0,1,6.022,2.031,1.313,1.313,0,0,1,.5,1.5,1.29,1.29,0,0,1-1.3.875,13.366,13.366,0,0,0-10.265-1.081,16.7,16.7,0,0,0-9.468,7.163,7.039,7.039,0,0,0-1.552,3.111,10.93,10.93,0,0,1-6.393,5.708,21.761,21.761,0,0,0-4.379,1.938"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_877"
        data-name="Path 877"
        d="M-133.89,15.839a3.1,3.1,0,0,0,3.1,3.1,3.1,3.1,0,0,0,3.1-3.1,3.1,3.1,0,0,0-3.1-3.1,3.1,3.1,0,0,0-3.1,3.1"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <line
        id="Line_567"
        data-name="Line 567"
        y2="2.37"
        transform="translate(-261.012 20.536)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.249"
      />
      <g id="Group_417-2" data-name="Group 417">
        <path
          id="Path_878"
          data-name="Path 878"
          d="M-125.034,15.277a6.257,6.257,0,0,0-1.331-1.662"
          fill="#f7f5f1"
          stroke="#1d3041"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.15"
        />
        <path
          id="Path_879"
          data-name="Path 879"
          d="M-126.739,13.24a11.81,11.81,0,0,0-1.829-1.33"
          fill="#f7f5f1"
          stroke="#1d3041"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.15"
        />
        <path
          id="Path_880"
          data-name="Path 880"
          d="M-129.067,11.661a6.61,6.61,0,0,0-1.663-.707"
          fill="#f7f5f1"
          stroke="#1d3041"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.15"
        />
        <path
          id="Path_881"
          data-name="Path 881"
          d="M-136.758,16.358A9.79,9.79,0,0,0-135.1,18.6"
          fill="#f7f5f1"
          stroke="#1d3041"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.15"
        />
        <path
          id="Path_882"
          data-name="Path 882"
          d="M-134.679,18.91a10.166,10.166,0,0,0,1.938,1.148"
          fill="#f7f5f1"
          stroke="#1d3041"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.15"
        />
        <path
          id="Path_883"
          data-name="Path 883"
          d="M-132.227,20.266a5.751,5.751,0,0,0,2.37.333"
          fill="#f7f5f1"
          stroke="#1d3041"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.15"
        />
      </g>
      <path
        id="Path_884"
        data-name="Path 884"
        d="M-368.312,11.718h0A3.214,3.214,0,0,0-365.1,8.5V-.458"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_885"
        data-name="Path 885"
        d="M-349.438,34.094h0a3.214,3.214,0,0,0-3.214,3.214V46.27"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_886"
        data-name="Path 886"
        d="M-349.438,11.718h0A3.214,3.214,0,0,1-352.652,8.5V-.458"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <path
        id="Path_887"
        data-name="Path 887"
        d="M-368.312,34.094h0a3.214,3.214,0,0,1,3.214,3.214V46.27"
        fill="#f7f5f1"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.48"
      />
      <line
        id="Line_568"
        data-name="Line 568"
        x1="2.162"
        transform="translate(-351.6 15.963)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_569"
        data-name="Line 569"
        x1="2.245"
        transform="translate(-354.385 15.963)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_570"
        data-name="Line 570"
        x1="2.245"
        transform="translate(-357.212 15.963)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_571"
        data-name="Line 571"
        x1="2.245"
        transform="translate(-359.998 15.963)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_572"
        data-name="Line 572"
        x1="2.245"
        transform="translate(-362.825 15.963)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_573"
        data-name="Line 573"
        x1="2.245"
        transform="translate(-365.61 15.963)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_574"
        data-name="Line 574"
        x1="2.12"
        transform="translate(-368.312 15.963)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_575"
        data-name="Line 575"
        x1="2.162"
        transform="translate(-351.6 29.89)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_576"
        data-name="Line 576"
        x1="2.245"
        transform="translate(-354.385 29.89)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_577"
        data-name="Line 577"
        x1="2.245"
        transform="translate(-357.212 29.89)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_578"
        data-name="Line 578"
        x1="2.245"
        transform="translate(-359.998 29.89)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_579"
        data-name="Line 579"
        x1="2.245"
        transform="translate(-362.825 29.89)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_580"
        data-name="Line 580"
        x1="2.245"
        transform="translate(-365.61 29.89)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
      <line
        id="Line_581"
        data-name="Line 581"
        x1="2.12"
        transform="translate(-368.312 29.89)"
        fill="none"
        stroke="#1d3041"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.15"
      />
    </g>
  </svg>
)
